module.exports = __webpack_public_path__ + "images/logo/tosho_prime_logo_d3b778fe417355b2ebbeaf30669c9e91.webp";